import { Box } from "@mui/material";
import { useEffect, useState } from "react";

import { Typography } from "@/Components/v2/atoms/Typography";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import { NewTableContent } from "./NewTableContent";
import TableDownload from "./TableDownload";
import TableFilter from "./TableFilter";

export const NewCustomReactTable = ({
  name,
  data,
  headers = [],
  wrapperWidth = `${100}%`,
  width = `${100}%`,
  isTableInteractive = null,
  currencySign,
  formatCurrency,
}) => {
  const { theme } = useInfo();

  const [columns, setColumns] = useState([]);
  const [checkedState, setCheckedState] = useState();

  const [filterHeader, setFilterHeader] = useState();
  const [filterColumns, setFilterColumns] = useState();

  useEffect(() => {
    const columns = headers.map((column) => {
      return {
        Header: column,
        accessor: column,
      };
    });
    setColumns(columns);

    setFilterColumns(columns);
    setFilterHeader(headers);
    setCheckedState(new Array(columns.length).fill(true));
  }, [data, headers]);

  const handleFilterCheckbox = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
    const tempColumns = columns.filter((column, index) => {
      return updatedCheckedState[index] && column;
    });
    const tempHeader = headers.filter((header, index) => {
      return updatedCheckedState[index] && header;
    });
    setFilterColumns(tempColumns);
    setFilterHeader(tempHeader);
  };

  return (
    <>
      {columns.length > 0 ? (
        <div data-testcomp="GraphTable">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginRight: "20px",
              marginBottom: "16px",
            }}
          >
            <>
              <Typography variant="h2" fontSize={20} fontWeight={600}>
                Insights Table
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <TableFilter
                  columns={columns}
                  checkedState={checkedState}
                  handleFilterCheckbox={handleFilterCheckbox}
                />
                <TableDownload name={name} data={data} columns={columns} />
              </Box>
            </>
          </Box>

          <NewTableContent
            name={name}
            width={width}
            wrapperWidth={wrapperWidth}
            columns={filterColumns}
            numbers={filterHeader.length}
            data={data}
            initialState={{
              sortBy: [{ id: filterHeader[0], asc: false }],
            }}
            isTableInteractive={isTableInteractive}
            colorTheme={theme.color}
            currencySign={currencySign}
            formatCurrency={formatCurrency}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};
